import React, { useEffect } from 'react';
import {
    Flex,
    Box,
    Text,
    VStack
} from '@chakra-ui/react';

import Const from '../Constants';
import AccordionBar from '../Components/AccordionBar';

import { useMeetingsStore } from '../Stores/MeetingsStore';

import MeetingsDetails from './MeetingsDetails';

const Meetings = ({ auth, userConfig, setUserConfig, type }) => {
    const meetings = useMeetingsStore((state) => state.meetings);
    const currentMeeting = useMeetingsStore((state) => state.currentMeeting);
    const setMeetings = useMeetingsStore((state) => state.setMeetings);
    const setCurrentMeeting = useMeetingsStore((state) => state.setCurrentMeeting);
    const loadMeetings = useMeetingsStore((state) => state.loadMeetings);
    const loadMeetingDetails = useMeetingsStore((state) => state.loadMeetingDetails);

    useEffect(() => {
      loadMeetings(auth, type);
    // eslint-disable-next-line
    }, [type]);

    useEffect(() => {
        // Lazy loading of the data of the meeting
        if(currentMeeting && !currentMeeting.data) {
          loadMeetingDetails(auth, currentMeeting.id);
        }
    // eslint-disable-next-line
    }, [currentMeeting]);

    return (
        <Box
            display={'flex'}
            justifyContent={Const.sCenter}
            alignItems={Const.sCenter}
            height={'100vh'}
            width={'100%'}
        >
            <Flex
              w={'100%'}
              alignItems={currentMeeting ? 'stretch' : Const.sCenter}
            >
                <AccordionBar
                  auth={auth}
                  userConfig={userConfig}
                  setUserConfig={setUserConfig}
                  type={type}
                  data={meetings}
                  setData={setMeetings}
                  current={currentMeeting}
                  setCurrent={setCurrentMeeting}
                />
                { currentMeeting ? (
                <MeetingsDetails
                  type={type}
                  auth={auth}
                />) : (
                  <VStack
                      w={'100%'}
                  >
                  <Text
                      fontSize={Const.SM}
                      color={Const.Gray165}
                  >
                      {`Select a ${type} or create a new one`}
                  </Text>
                </VStack>
                )
                }
            </Flex>
        </Box>
    );
};

export default Meetings;
